module.exports = __webpack_public_path__ + "static/6-ace38047d9925ef97f688995dfb58ff2.jpg";